export default __webpack_public_path__ + "static/media/product_healthCheck_Cn.d615e303.webp";